import { render, staticRenderFns } from "./PreviewTransferDuo.vue?vue&type=template&id=7e115a22&scoped=true&"
import script from "./PreviewTransferDuo.vue?vue&type=script&lang=js&"
export * from "./PreviewTransferDuo.vue?vue&type=script&lang=js&"
import style0 from "./PreviewTransferDuo.vue?vue&type=style&index=0&id=7e115a22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e115a22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
